module.exports = __webpack_public_path__ + "static/media/Namibia - NA.a9786152.png";